import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.507 14.667h6.986c1.84 0 2.574-1.127 2.66-2.5L14.5 6.66A2.5 2.5 0 0 0 12 4c-.407 0-.78-.233-.967-.593l-.48-.967c-.306-.607-1.106-1.107-1.786-1.107H7.24c-.687 0-1.487.5-1.793 1.107l-.48.967C4.78 3.767 4.407 4 4 4a2.5 2.5 0 0 0-2.5 2.66l.347 5.507c.08 1.373.82 2.5 2.66 2.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "var(--color-zinc-50)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.091",
      d: "M7 5.333h2M8 12a2.17 2.17 0 0 0 2.167-2.167A2.17 2.17 0 0 0 8 7.667a2.17 2.17 0 0 0-2.167 2.166A2.17 2.17 0 0 0 8 12"
    }, null, -1)
  ]))]))
}
export default { render: render }